var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a.75.75 0 010 1.5H4.75a.25.25 0 00-.25.25v14.5c0 .138.112.25.25.25H12a.75.75 0 010 1.5H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3H12z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.97 8.47a.75.75 0 011.06 0l2.823 2.823.069.076a1 1 0 010 1.262l-.069.076-2.823 2.823-.056.052a.75.75 0 01-1.056-1.056l.052-.056 1.72-1.72H9a.75.75 0 010-1.5h7.69l-1.72-1.72a.75.75 0 010-1.06z",
    fill: "currentColor"
  })));
}
SvgLogOut.displayName = 'LogOut';
export default SvgLogOut;